import React from "react";

const assetUrl = (assetPath) => {
  if (!assetPath) {
    return assetPath;
  }

  return assetPath.startsWith("/") || assetPath.startsWith("http")
    ? assetPath
    : `/${assetPath}`;
};

export const Image = ({ title, largeImage, smallImage }) => {
  const largeImageUrl = assetUrl(largeImage);
  const smallImageUrl = assetUrl(smallImage);

  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImageUrl} title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={smallImageUrl} className="img-responsive" alt={title} />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
